import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  id: "footer",
  class: "overflow-hidden"
};
const _hoisted_2 = {
  class: "footer-main"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row"
};
const _hoisted_5 = {
  class: "col-12"
};
const _hoisted_6 = {
  class: "nav row gy-3"
};
const _hoisted_7 = {
  class: "col-xl-2 col-md-2"
};
const _hoisted_8 = {
  class: "col-xl-2 col-md-2"
};
const _hoisted_9 = {
  class: "col-xl-2 col-md-2"
};
const _hoisted_10 = {
  class: "col-xl-2 col-md-2"
};
const _hoisted_11 = {
  key: 0,
  class: "spinner-border",
  role: "status"
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  class: "col-xl-4 col-md-6 width-50 address-holder"
};
const _hoisted_14 = {
  class: "address"
};
const _hoisted_15 = {
  href: "https://www.google.com/maps/place/G1G+Travel+%26+Visitors+Insurance/@37.294471,-121.909114,17z/data=!3m1!4b1!4m6!3m5!1s0x808fcca33f35b74d:0x2435a57e2c528abb!8m2!3d37.294471!4d-121.909114!16s%2Fg%2F11bbw_4rsc?hl=en-US&entry=ttu"
};
const _hoisted_16 = {
  class: "row"
};
const _hoisted_17 = {
  class: "col-xl-4 col-sm-12"
};
const _hoisted_18 = {
  class: "social"
};
const _hoisted_19 = {
  class: "d-flex mb-3 mt-3"
};
const _hoisted_20 = {
  class: "middle container"
};
const _hoisted_21 = {
  class: "row justify-content-center d-flex"
};
const _hoisted_22 = {
  class: "col-xl-8 col-lg-11 col-12"
};
const _hoisted_23 = {
  class: "feature"
};
const _hoisted_24 = {
  class: "icon"
};
const _hoisted_25 = {
  alt: "global reach G1G"
};
const _hoisted_26 = {
  class: "icon"
};
const _hoisted_27 = {
  alt: "Claim Paid"
};
const _hoisted_28 = {
  class: "text"
};
const _hoisted_29 = {
  class: "col-xl-4 col-6 text-right"
};
const _hoisted_30 = {
  class: "newsletter"
};
const _hoisted_31 = {
  id: "newsletter-form",
  method: "post"
};
const _hoisted_32 = ["error"];
const _hoisted_33 = {
  key: 1,
  class: "go-arrow material-symbols-outlined sub-arrow"
};
const _hoisted_34 = {
  key: 2,
  class: "go-arrow material-symbols-outlined"
};
const _hoisted_35 = {
  class: "text-danger text-center"
};
const _hoisted_36 = {
  class: "row justify-content-center"
};
const _hoisted_37 = {
  class: "col-xl-12 col-lg-11 col-12"
};
const _hoisted_38 = {
  class: "bottom container logo-contain"
};
const _hoisted_39 = {
  class: "logo h-auto"
};
const _hoisted_40 = {
  alt: "G1G Travel & Visitors Insurance"
};
const _hoisted_41 = {
  class: "bottom container"
};
const _hoisted_42 = {
  class: "text-capitalize mb-0"
};
const _hoisted_43 = {
  class: "d-xl-flex d-block address-bottom"
};
const _hoisted_44 = {
  class: ""
};
import { createNamespacedHelpers } from "vuex-composition-helpers";
import { computed, ref } from "vue";
import { newsletter, riskEvaluation } from "@/endpoints";
import { toRaw } from "@vue/reactivity";
import Input from "@/components/input.vue";
import { axios } from "@/config/axios";
import { STATE_STATUSES } from "@/helpers/constants";
import { newsLetterValidation, newsLetterState } from "@/composable/vuelidate";
import { notify } from "@kyvg/vue3-notification";
import Loader from "@/components/globalComponent/loader.vue";
import { track } from "@/analytics/events";
import { uuid } from "vue-uuid";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
export default {
  __name: 'footer',
  setup(__props) {
    const focused = ref(false);
    const error = ref('');
    const {
      useState
    } = createNamespacedHelpers("user");
    const {
      status,
      user
    } = useState(["status", "user"]);
    const loading = ref(false);
    const trackSegmentClick = event => {
      // code for segment
      track(`Static Clickable`, {
        source: `Footer - ${event}`
      });
    };
    const submitNewsletter = async () => {
      let check = await newsLetterValidation.value.$validate();
      if (check) {
        track("Email Submitted", {
          email: newsLetterState.value.email,
          newsletter_type: 'newsletter'
        });
        try {
          loading.value = true;
          const response = await axios.post(newsletter, {
            email: newsLetterState.value.email,
            newsletter_type: 'newsletter'
          });
          if (response) {
            if (response.data.errors.length > 0) {
              error.value = response.data.errors[0].code;
            }
            if (response.data._metadata.outcomeCode === 200) {
              loading.value = false;
              newsLetterState.value.email = '';
              notify({
                type: "success",
                title: response.data._metadata.message,
                text: "You would receive an email with the latest updates"
              });
            }
            setTimeout(() => {
              error.value = '';
              loading.value = false;
            }, 3000);
          }
        } catch (e) {
          console.log("error", e);
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[25] || (_cache[25] = _createElementVNode("h4", null, "USE G1G PRODUCTS", -1)), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/travel-protection-insurance",
        onClick: _cache[0] || (_cache[0] = $event => trackSegmentClick('Travel Insurance'))
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("Travel Insurance")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/usa-visitor-health-insurance",
        onClick: _cache[1] || (_cache[1] = $event => trackSegmentClick('USA Visitor Insurance'))
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("USA Visitor Insurance")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/annual-travel-insurance",
        onClick: _cache[2] || (_cache[2] = $event => trackSegmentClick('Annual Travel Insurance'))
      }, {
        default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("Annual Travel Insurance")])),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_8, [_cache[26] || (_cache[26] = _createElementVNode("h4", null, "SELL G1G PRODUCTS", -1)), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("a", {
        target: "_blank",
        href: "https://cloud.g1g.com",
        onClick: _cache[3] || (_cache[3] = $event => trackSegmentClick('G1G Cloud'))
      }, "G1G Cloud")]), _createElementVNode("li", null, [_createElementVNode("a", {
        target: "_blank",
        href: "https://cloud.g1g.com/sell-travel-insurance",
        onClick: _cache[4] || (_cache[4] = $event => trackSegmentClick('Sell Travel Insurance'))
      }, "Sell Travel Insurance")]), _createElementVNode("li", null, [_createElementVNode("a", {
        target: "_blank",
        href: "https://cloud.g1g.com/api",
        onClick: _cache[5] || (_cache[5] = $event => trackSegmentClick('G1G API'))
      }, "G1G API")])])]), _createElementVNode("div", _hoisted_9, [_cache[30] || (_cache[30] = _createElementVNode("h4", null, "ABOUT G1G TRAVEL", -1)), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/about-us",
        onClick: _cache[6] || (_cache[6] = $event => trackSegmentClick('Why We Exist'))
      }, {
        default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("Why We Exist")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/our-mission",
        onClick: _cache[7] || (_cache[7] = $event => trackSegmentClick('Our Mission'))
      }, {
        default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("Our Mission")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/media/media-kit",
        onClick: _cache[8] || (_cache[8] = $event => trackSegmentClick('Media'))
      }, {
        default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("Media")])),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_10, [_cache[35] || (_cache[35] = _createElementVNode("h4", null, "MY G1G", -1)), _createElementVNode("ul", null, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : (_openBlock(), _createElementBlock("li", _hoisted_12, [_unref(user) ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: "/dashboard/extend-policy-plans"
      }, {
        default: _withCtx(() => _cache[31] || (_cache[31] = [_createTextVNode("Customer Portal")])),
        _: 1
      })) : (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        to: "/login",
        onClick: _cache[9] || (_cache[9] = $event => trackSegmentClick('Login Clicked'))
      }, {
        default: _withCtx(() => _cache[32] || (_cache[32] = [_createTextVNode("Login")])),
        _: 1
      }))])), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/faq",
        onClick: _cache[10] || (_cache[10] = $event => trackSegmentClick('Help Center'))
      }, {
        default: _withCtx(() => _cache[33] || (_cache[33] = [_createTextVNode("Help Center")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/contact-us",
        onClick: _cache[11] || (_cache[11] = $event => trackSegmentClick('Contact'))
      }, {
        default: _withCtx(() => _cache[34] || (_cache[34] = [_createTextVNode("Contact")])),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_13, [_cache[37] || (_cache[37] = _createElementVNode("h4", {
        class: "text-uppercase"
      }, "Headquarters", -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("a", _hoisted_15, [_createElementVNode("div", null, [_createVNode(CloudinaryImage, {
        alt: "Location",
        class: "img-fluid",
        imageName: "G1G-logo-new_1_ky6ma9"
      }), _cache[36] || (_cache[36] = _createElementVNode("address", null, [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-0.5 -0.5 10 10",
        id: "Pin-Location-1--Streamline-Streamline--3.0",
        height: "16",
        width: "16"
      }, [_createElementVNode("desc", null, "Pin Location 1 Streamline Icon: https://streamlinehq.com"), _createElementVNode("g", null, [_createElementVNode("path", {
        d: "M6.27375 6.85875a0.375 0.375 0 0 0 -0.06375 0.75 10.935 10.935 0 0 1 1.41375 0.195 0.09375 0.09375 0 0 1 0 0.18375A14.951249999999998 14.951249999999998 0 0 1 4.5 8.25a14.951249999999998 14.951249999999998 0 0 1 -3.1237500000000002 -0.26625 0.09375 0.09375 0 0 1 0 -0.18375 10.8225 10.8225 0 0 1 1.39875 -0.195 0.375 0.375 0 0 0 0.34125 -0.405 0.375 0.375 0 0 0 -0.405 -0.34125C0 7.0874999999999995 0 7.6499999999999995 0 7.875c0 1.00125 3.12 1.125 4.5 1.125s4.5 -0.10874999999999999 4.5 -1.125c0 -0.22499999999999998 0 -0.7875000000000001 -2.72625 -1.0162499999999999Z",
        fill: "#ffffff",
        "stroke-width": "1"
      }), _createElementVNode("path", {
        d: "M4.5 8.100000000000001a0.375 0.375 0 0 0 0.315 -0.17250000000000001c0.75 -1.1475 2.445 -3.9487499999999995 2.445 -5.1674999999999995a2.7600000000000002 2.7600000000000002 0 0 0 -5.5200000000000005 0c0 1.21875 1.71 4.0200000000000005 2.445 5.1674999999999995a0.375 0.375 0 0 0 0.315 0.17250000000000001ZM3.1875 2.625a1.3125 1.3125 0 1 1 1.3125 1.3125A1.3125 1.3125 0 0 1 3.1875 2.625Z",
        fill: "#ffffff",
        "stroke-width": "1"
      })])]), _createTextVNode(" 1494 Hamilton Ave, San Jose, CA 95125 ")], -1))])])])])])])]), _createElementVNode("div", _hoisted_16, [_cache[44] || (_cache[44] = _createElementVNode("div", {
        class: "col-xl-8"
      }, null, -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[42] || (_cache[42] = _createElementVNode("h6", null, "Follow", -1)), _createElementVNode("ul", _hoisted_19, [_createElementVNode("li", null, [_createElementVNode("a", {
        onClick: _cache[12] || (_cache[12] = $event => trackSegmentClick('Youtube Link')),
        href: "https://youtube.com/G1G_Travel",
        target: "_blank"
      }, _cache[38] || (_cache[38] = [_createElementVNode("svg", {
        fill: "#ffffff",
        height: "30px",
        viewBox: "0 0 30 30",
        width: "30px",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M 15 4 C 10.814 4 5.3808594 5.0488281 5.3808594 5.0488281 L 5.3671875 5.0644531 C 3.4606632 5.3693645 2 7.0076245 2 9 L 2 15 L 2 15.001953 L 2 21 L 2 21.001953 A 4 4 0 0 0 5.3769531 24.945312 L 5.3808594 24.951172 C 5.3808594 24.951172 10.814 26.001953 15 26.001953 C 19.186 26.001953 24.619141 24.951172 24.619141 24.951172 L 24.621094 24.949219 A 4 4 0 0 0 28 21.001953 L 28 21 L 28 15.001953 L 28 15 L 28 9 A 4 4 0 0 0 24.623047 5.0546875 L 24.619141 5.0488281 C 24.619141 5.0488281 19.186 4 15 4 z M 12 10.398438 L 20 15 L 12 19.601562 L 12 10.398438 z"
      })], -1)]))]), _createElementVNode("li", null, [_createElementVNode("a", {
        onClick: _cache[13] || (_cache[13] = $event => trackSegmentClick('Instagram Link')),
        href: "https://www.instagram.com/g1g_travel/",
        target: "_blank"
      }, _cache[39] || (_cache[39] = [_createElementVNode("svg", {
        fill: "#ffffff",
        height: "28px",
        viewBox: "0 0 24 24",
        width: "30px",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z"
      })], -1)]))]), _createElementVNode("li", null, [_createElementVNode("a", {
        onClick: _cache[14] || (_cache[14] = $event => trackSegmentClick('Tiktok Link')),
        href: "https://www.tiktok.com/@g1g_travel?_t=8kJO6Z3XjwY&_r=1",
        target: "_blank"
      }, _cache[40] || (_cache[40] = [_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26.7265",
        height: "30.668",
        viewBox: "0 0 53.453 61.336",
        fill: "#fff"
      }, [_createElementVNode("path", {
        id: "tiktok-svgrepo-com",
        d: "M53.537,16.369A14.7,14.7,0,0,1,41.977,3.352V2H31.413V43.924a8.88,8.88,0,0,1-15.948,5.345l-.006,0,.006,0a8.877,8.877,0,0,1,9.76-13.829V24.707a19.4,19.4,0,1,0,16.752,19.22V22.5a25.089,25.089,0,0,0,14.636,4.679v-10.5A14.814,14.814,0,0,1,53.537,16.369Z",
        transform: "translate(-3.16 -2)"
      })], -1)]))]), _createElementVNode("li", null, [_createElementVNode("a", {
        onClick: _cache[15] || (_cache[15] = $event => trackSegmentClick('Linkedin Link')),
        href: "https://www.linkedin.com/company/g1g-travel",
        target: "_blank"
      }, _cache[41] || (_cache[41] = [_createStaticVNode("<svg fill=\"#ffffff\" width=\"22px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 310 310\" xml:space=\"preserve\" data-v-60e9aa16><g id=\"XMLID_801_\" data-v-60e9aa16><path id=\"XMLID_802_\" d=\"M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73\r\n            C77.16,101.969,74.922,99.73,72.16,99.73z\" data-v-60e9aa16></path><path id=\"XMLID_803_\" d=\"M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4\r\n            c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z\" data-v-60e9aa16></path><path id=\"XMLID_804_\" d=\"M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599\r\n            c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319\r\n            c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995\r\n            C310,145.43,300.549,94.761,230.454,94.761z\" data-v-60e9aa16></path></g></svg>", 1)]))])]), _cache[43] || (_cache[43] = _createStaticVNode("<h6 data-v-60e9aa16>Contact</h6><div class=\"sc-dlfnbm sc-hKgILt kSpEsb bGtxuC\" data-v-60e9aa16><a href=\"tel:1-408-478-9990\" class=\"sc-bTvRPi bRuBjl\" data-v-60e9aa16><svg width=\"13\" xmlns=\"http://www.w3.org/2000/svg\" height=\"13\" fill=\"none\" viewBox=\"0 0 13 13\" data-v-60e9aa16><path clip-rule=\"evenodd\" d=\"M3.71705 9.24783C5.32705 10.8578 7.10705 11.9878 8.93705 12.3578C11.687 12.9078 13.257 9.99783 12.027 8.52783C10.827 7.08783 8.44705 5.68783 7.36705 7.74783C7.27705 7.90783 6.89705 8.81783 5.53705 7.44783C4.17705 6.08783 5.06705 5.69783 5.23705 5.61783C7.29705 4.53783 5.88705 2.14783 4.44705 0.937829C2.96705 -0.292171 0.0670464 1.27783 0.617046 4.03783C0.987046 5.84783 2.12705 7.65783 3.72705 9.25783L3.71705 9.24783Z\" fill=\"white\" fill-rule=\"evenodd\" data-v-60e9aa16></path></svg><span class=\"sc-jONnTn gqkNTh\" data-v-60e9aa16>1-408-478-9990</span></a><div class=\"sc-hlTvYk gkvoHV\" data-v-60e9aa16></div><a href=\"mailto:support@g1g.com\" class=\"sc-bTvRPi bRuBjl\" data-v-60e9aa16><svg width=\"13\" xmlns=\"http://www.w3.org/2000/svg\" height=\"13\" fill=\"none\" viewBox=\"0 0 13 13\" data-v-60e9aa16><path d=\"M1.87205 1.85449C1.36225 1.85449 0.948975 2.26777 0.948975 2.77757V3.35996C0.948975 3.39983 0.972652 3.43588 1.00923 3.45173L6.65631 5.8974C6.91401 6.009 7.20676 6.00711 7.46299 5.89217L12.8899 3.45795C12.9258 3.44183 12.949 3.40611 12.949 3.36671V2.77757C12.949 2.26777 12.5357 1.85449 12.0259 1.85449H1.87205Z\" fill=\"white\" data-v-60e9aa16></path><path d=\"M12.949 5.00161C12.949 4.92844 12.873 4.88005 12.8067 4.911L7.47742 7.39923C7.21298 7.5227 6.9078 7.52448 6.64194 7.40412L1.09022 4.89076C1.02402 4.86079 0.948975 4.9092 0.948975 4.98186V10.1622C0.948975 10.672 1.36225 11.0853 1.87205 11.0853H12.0259C12.5357 11.0853 12.949 10.672 12.949 10.1622V5.00161Z\" fill=\"white\" data-v-60e9aa16></path></svg><span class=\"sc-jONnTn gqkNTh\" data-v-60e9aa16>support@g1g.com</span></a></div>", 2))])])])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("ul", _hoisted_23, [_createElementVNode("li", null, [_createElementVNode("div", _hoisted_24, [_withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [[_directive_lazy, {
        src: require('@/assets/images/global.svg')
      }]])]), _cache[45] || (_cache[45] = _createElementVNode("div", {
        class: "text"
      }, [_createElementVNode("h4", null, "1 Million +"), _createTextVNode(" Trips protected ")], -1))]), _createElementVNode("li", null, [_createElementVNode("div", _hoisted_26, [_withDirectives(_createElementVNode("img", _hoisted_27, null, 512), [[_directive_lazy, {
        src: require('@/assets/images/stars.svg')
      }]])]), _cache[46] || (_cache[46] = _createElementVNode("div", {
        class: "text"
      }, [_createElementVNode("h4", null, "20 Million +"), _createTextVNode(" In claims paid ")], -1))]), _createElementVNode("li", null, [_cache[48] || (_cache[48] = _createElementVNode("div", {
        class: "icon"
      }, [_createElementVNode("div", {
        class: "icon-trophy-wrapper"
      }, [_createElementVNode("img", {
        class: "icon-trophy",
        alt: "Experience",
        src: "https://res.cloudinary.com/dhw4x5rfc/image/upload/v1740095592/trophy_pf9mj8.svg"
      })])], -1)), _createElementVNode("div", _hoisted_28, [_createElementVNode("h4", null, _toDisplayString(new Date().getFullYear() - 1985), 1), _cache[47] || (_cache[47] = _createTextVNode(" Years of service "))])])])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_cache[49] || (_cache[49] = _createElementVNode("p", null, "Travel alerts & safety tips delivered to you", -1)), _createElementVNode("form", _hoisted_31, [_createElementVNode("div", {
        class: _normalizeClass(["form-group", {
          'focused': _unref(newsLetterState).email
        }])
      }, [_withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["form-control", {
          error: _unref(newsLetterValidation).email.$errors.length
        }]),
        placeholder: "Email",
        type: "email",
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(newsLetterState).email = $event),
        onFocusin: _cache[17] || (_cache[17] = $event => focused.value = true),
        onFocusout: _cache[18] || (_cache[18] = $event => focused.value = false),
        error: _unref(newsLetterValidation).email.$errors
      }, null, 42, _hoisted_32), [[_vModelText, _unref(newsLetterState).email]]), _createElementVNode("button", {
        class: "arrow-submit-btn",
        onClick: submitNewsletter,
        type: "button"
      }, [loading.value ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        parentClass: "d-flex justify-content-start",
        childClass: "spinner-grow spinner-grow-sm"
      })) : _createCommentVNode("", true), _unref(newsLetterState).email && !loading.value ? (_openBlock(), _createElementBlock("span", _hoisted_33, " trending_flat ")) : !loading.value ? (_openBlock(), _createElementBlock("span", _hoisted_34, " trending_flat")) : _createCommentVNode("", true)])], 2)]), _createElementVNode("span", _hoisted_35, _toDisplayString(error.value), 1)])])])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_withDirectives(_createElementVNode("img", _hoisted_40, null, 512), [[_directive_lazy, {
        src: require('@/assets/img/logo-m.svg')
      }]])])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_42, "© 1985 - " + _toDisplayString(new Date().getFullYear()) + " Go One Global Inc.", 1)]), _createElementVNode("div", _hoisted_43, [_cache[54] || (_cache[54] = _createElementVNode("p", null, "Founded and located in Silicon Valley, CA", -1)), _createElementVNode("ul", _hoisted_44, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/terms-conditions",
        onClick: _cache[19] || (_cache[19] = $event => trackSegmentClick('Terms & conditions'))
      }, {
        default: _withCtx(() => _cache[50] || (_cache[50] = [_createTextVNode("Terms & conditions")])),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/privacy-policy",
        onClick: _cache[20] || (_cache[20] = $event => trackSegmentClick('Privacy'))
      }, {
        default: _withCtx(() => _cache[51] || (_cache[51] = [_createTextVNode("Privacy")])),
        _: 1
      })]), _cache[53] || (_cache[53] = _createElementVNode("br", {
        class: "d-sm-none d-block"
      }, null, -1)), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/accessibility",
        onClick: _cache[21] || (_cache[21] = $event => trackSegmentClick('Accessibility'))
      }, {
        default: _withCtx(() => _cache[52] || (_cache[52] = [_createTextVNode("Accessibility")])),
        _: 1
      })])])])])])])]);
    };
  }
};